var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaAdminLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_2832_4983)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2832_4983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9002 19.7438C20.8267 19.7438 21.629 19.4116 22.2845 18.7559C22.94 18.1004 23.2723 17.2984 23.2723 16.3718C23.2723 15.4455 22.94 14.6434 22.2844 13.9877C21.6288 13.3323 20.8266 13 19.9002 13C18.9736 13 18.1716 13.3323 17.5161 13.9878C16.8606 14.6433 16.5282 15.4454 16.5282 16.3718C16.5282 17.2984 16.8606 18.1006 17.5162 18.7561C18.1718 19.4114 18.974 19.7438 19.9002 19.7438Z",
    fill: "url(#paint1_linear_2832_4983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8004 23.7652C25.7815 23.4924 25.7433 23.1948 25.687 22.8806C25.6301 22.564 25.557 22.2647 25.4694 21.9912C25.3789 21.7084 25.2559 21.4292 25.1038 21.1617C24.9459 20.884 24.7605 20.6421 24.5524 20.4432C24.3348 20.235 24.0685 20.0676 23.7604 19.9455C23.4534 19.8241 23.1132 19.7626 22.7493 19.7626C22.6064 19.7626 22.4682 19.8212 22.2013 19.995C22.037 20.1021 21.8448 20.226 21.6304 20.363C21.447 20.4799 21.1985 20.5894 20.8917 20.6885C20.5923 20.7854 20.2883 20.8345 19.9883 20.8345C19.6882 20.8345 19.3843 20.7854 19.0846 20.6885C18.7781 20.5895 18.5296 20.48 18.3465 20.3632C18.134 20.2274 17.9417 20.1035 17.775 19.9949C17.5084 19.8211 17.3701 19.7625 17.2272 19.7625C16.8632 19.7625 16.5231 19.8241 16.2162 19.9456C15.9084 20.0675 15.6419 20.2349 15.4241 20.4433C15.2161 20.6424 15.0306 20.8841 14.8729 21.1617C14.7209 21.4292 14.5979 21.7083 14.5073 21.9913C14.4198 22.2648 14.3467 22.564 14.2899 22.8806C14.2336 23.1944 14.1953 23.4921 14.1764 23.7655C14.1578 24.0334 14.1484 24.3114 14.1484 24.5922C14.1484 25.323 14.3808 25.9147 14.8389 26.351C15.2913 26.7815 15.89 27 16.618 27H23.3591C24.0871 27 24.6856 26.7816 25.1382 26.351C25.5964 25.915 25.8287 25.3233 25.8287 24.5921C25.8286 24.31 25.8191 24.0318 25.8004 23.7652Z",
    fill: "url(#paint2_linear_2832_4983)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2832_4983",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2832_4983",
    x1: 19.9002,
    y1: 6.25616,
    x2: 19.9002,
    y2: 26.4877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2832_4983",
    x1: 19.9886,
    y1: 12.5249,
    x2: 19.9886,
    y2: 34.2375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2832_4983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaAdminLogo);
export default __webpack_public_path__ + "static/media/SA_AdminLogo.2f6ded198f06ac6af053ad9f1f5c1a81.svg";
export { ForwardRef as ReactComponent };